import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../../Utils/GlobalUtils';

import Loading from '../../../Loading'

import styles from '../../../../styles/DynamicModal.module.css';

import IconContainer from '../../../IconContainer';
import { ReactComponent as XIcon } from '../../../../icons/x-close.svg';

const EditTK = ({ closeModal, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        TK: '',
        TK_date: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        axios.get(`/api/get-user-tk?user_id=${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            setFormInfo(response.data);
            setStatus(null);
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.TK) {
            newErrors.TK = 'Обязательное поле';
        }
        if (formInfo.TK && (formInfo.TK.length > 15)) {
            newErrors.TK = 'Значение не может быть более 15 символов';
        }
        if (!formInfo.TK_date) {
            newErrors.TK_date = 'Обязательное поле';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const changeData = () => {
        axios.put(`/api/change-user-tk`, {
            user_id: userId,
            tk_number: formInfo.TK,
            tk_date: normalizeDate(formInfo.TK_date),
        }).then(() => {
            setStatus('Данные изменены');
            openTimeModal('Данные успешно сохранены', 'success');
            closeModal();
            onSuccess();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            changeData();
        }
        setLoading(false);
    }


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>Редактирование сведений трудовой книжки</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Серия и номер</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.TK} 
                                onChange={handleChange('TK')} 
                                className={errorsForm.TK ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='15' 
                                disabled={loading}
                                required />
                                {errorsForm.TK && <div className='errorUnderInput'>{errorsForm.TK}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата выдачи ТК</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.TK_date?.split('T')[0]}
                                onChange={handleChange('TK_date')} 
                                className={errorsForm.TK_date ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.TK_date && <div className='errorUnderInput'>{errorsForm.TK_date}</div>}
                            </div>
                        </div>
                    </div>
                    {/* <div className='labelInputWrapper'>
                        <a className='label'>Скан</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.tk_date} 
                                onChange={handleChange('tk_date')} 
                                className={errorsForm.tk_date ? 'inputError' : ''}
                                placeholder='Если есть' 
                                minLength='' 
                                maxLength='50' 
                                disabled={loading}
                                required />
                                {errorsForm.tk_date && <div className='errorUnderInput'>{errorsForm.tk_date}</div>}
                            </div>
                        </div>
                    </div> */}
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        Сохранить
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditTK;